import React, { useState, useEffect, useRef } from "react";

// Model Layout Component - MentalHealth
const playBounce = (event, state) => {
  const el = event.currentTarget;
  el.classList.remove("map-hover-enter", "map-hover-leave");
  void el.offsetWidth;
  el.classList.add(state);
};

const bounceHandlers = {
  onMouseEnter: (e) => playBounce(e, "map-hover-enter"),
  onMouseLeave: (e) => playBounce(e, "map-hover-leave"),
};

const mentalLayers = [
  {
    id: "mhm1",
    src: "/assets/svgs/mental-health-svgs/mobile-svgs/mhm1.svg",
    alt: "mental health",
    style: { right: "-42%", top: "8%", zIndex: 10 },
  },
  {
    id: "mhm2",
    src: "/assets/svgs/mental-health-svgs/mobile-svgs/mhm2.svg",
    alt: "mental health",
    style: { right: "-8%", top: "27%", zIndex: 5 },
  },
  {
    id: "mhm3",
    src: "/assets/svgs/mental-health-svgs/mobile-svgs/mhm3.svg",
    alt: "mental health",
    style: { left: "30.5%", top: "22.7%" },
  },
  {
    id: "mhm4",
    src: "/assets/svgs/mental-health-svgs/mobile-svgs/mhm4.svg",
    alt: "mental health",
    style: { right: "-32%", bottom: "-18.5%" },
  },
  {
    id: "mhm5",
    src: "/assets/svgs/mental-health-svgs/mobile-svgs/mhm5.svg",
    alt: "mental health",
    style: { left: "30%", top: "42.5%" },
  },
  {
    id: "mhm6",
    src: "/assets/svgs/mental-health-svgs/mobile-svgs/mhm6.svg",
    alt: "mental health",
    style: { left: "46%", bottom: "-14.5%" },
  },
];

const MentalHealthMobileModel = ({
  className = "",
  showTooltips = true,
  isParentLoading = false,
  isPopUpOpen = false,
}) => {
  const [shouldJiggle, setShouldJiggle] = useState(false);
  const jiggleTriggeredRef = useRef(false);

  useEffect(() => {
    if (!isParentLoading && !isPopUpOpen && !jiggleTriggeredRef.current) {
      jiggleTriggeredRef.current = true;
      const timer = setTimeout(() => {
        setShouldJiggle(true);
        const stopTimer = setTimeout(() => {
          setShouldJiggle(false);
        }, 1500);
        return () => clearTimeout(stopTimer);
      }, 600); // Starts slightly after loader/popup clears
      return () => clearTimeout(timer);
    }
  }, [isParentLoading, isPopUpOpen]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const getScrollTarget = (layerId) => {
    const scrollMap = {
      mhm1: "emotional-support",
      mhm5: "bangladesh",
      mhm4: "nepal",
      mhm6: "indonesia",
      mhm3: "india",
    };
    return scrollMap[layerId];
  };

  return (
    <main className="relative pt-5">
      <section className="p-2">
        <div
          className={`relative mx-auto aspect-[4/8] max-w-[500px] ${className}`}
        >
          {mentalLayers.map((layer) => {
            const interactive = layer.id !== "mhm2";
            const hoverTiming = {
              "--map-seq-name": "mapSeqReveal",
              "--map-seq-duration": "1200ms",
              "--map-seq-delay": "0ms",
            };

            const tooltipPos = (() => {
              switch (layer.tooltipPlacement) {
                case "left":
                  return "left-full top-1/2 -translate-y-1/2 ml-2";
                case "right":
                  return "right-full top-1/2 -translate-y-1/2 mr-2";
                case "top":
                  return "bottom-[106%] left-[71%] -translate-x-1/2 -mt-2";
                default:
                  return "top-full left-1/2 -translate-x-1/2 mt-2";
              }
            })();

            const scrollTarget = getScrollTarget(layer.id);
            const handleClick = scrollTarget
              ? () => scrollToSection(scrollTarget)
              : undefined;

            return (
              <div
                key={layer.id}
                className={`absolute -translate-x-1/2 -translate-y-1/2 ${
                  interactive ? "group" : ""
                }`}
                style={layer.style}
              >
                <div className="relative">
                  <div className={interactive && shouldJiggle ? "animate-jiggle" : ""}>
                    <img
                      src={layer.src}
                      alt={layer.alt}
                      loading="lazy"
                      className={`select-none object-contain max-w-max ${
                        interactive
                          ? "map-hover-bounce hover:cursor-pointer pointer-events-auto map-seq"
                          : "pointer-events-none"
                      }`}
                      style={interactive ? { ...hoverTiming } : undefined}
                      {...(interactive ? bounceHandlers : {})}
                      {...(handleClick ? { onClick: handleClick } : {})}
                    />
                  </div>
                  {interactive && layer.tooltip && showTooltips && (
                    <span
                      className={`pointer-events-none z-50 absolute rounded-md bg-[#FEFBF6] p-2 text-[11px] font-normal text-black text-nowrap opacity-0 transition-opacity duration-200 group-hover:opacity-100 ${tooltipPos}`}
                    >
                      {layer.tooltip}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default MentalHealthMobileModel;
